import { useState } from 'react';
import Modal from '../../../components/modal/Modal';
import { useStatusModalContext } from '../../../contexts/StatusModalContext';
import { useDict } from '../../../contexts/LanguageContext';
import { postDeleteComment } from '../src/investmentNoteApis';

const DeleteCommentModal = ({ isOpen, setIsOpen, handleClose, deleteCommentRequest, deleteComment }) => {
    const dict = useDict();

    const { openStatusModal } = useStatusModalContext();

    const [isLoading, setIsLoading] = useState(false);

    const handleDelete = async () => {
        setIsLoading(true);
        await postDeleteComment(deleteCommentRequest, handlePostDeleteComment, handlePostDeleteCommentError);
        setIsLoading(false);
    };

    const handlePostDeleteComment = () => {
        deleteComment(deleteCommentRequest.comment_id);
        setIsOpen(false);
        openStatusModal({
            message: dict.deleteCommentSuccessfulMessage,
            title: dict.deleteComment,
            isSuccess: true,
            refresh: false,
        });
    };

    const handlePostDeleteCommentError = (error) => {
        openStatusModal({
            title: dict.deleteComment,
            message: dict.deleteCommentFailedMessage,
            refresh: false,
            isSuccess: false,
        });
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            onCancel={handleClose}
            onSubmit={handleDelete}
            cancelText={dict.cancel}
            submitText={dict.confirm}
            title={dict.deleteComment}
            headerType="comment"
            submitBtnProps={{
                disabled: isLoading,
            }}
            cancelBtnProps={{
                disabled: isLoading,
            }}
            testID="deleteCommentModal"
            submitShown
        >
            <div className="modal__body">
                <div data-cy="delete__confirmation" className="mx-auto">
                    <p>{dict.deleteCommentConfirmation}</p>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteCommentModal;
